<script setup>
import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import TfPopupShell from './TfPopupShell.vue';

const props = defineProps({
  initialView: { type: String, default: 'leads' },
});
const emit = defineEmits(['close']);

function detectTheme() {
  const root = document.documentElement;
  const body = document.body;
  const dark =
    (body && body.classList.contains('dark')) ||
    root.classList.contains('dark') ||
    root.dataset.theme === 'dark' ||
    root.getAttribute('color-scheme') === 'dark';
  return dark ? 'dark' : 'light';
}

const theme = ref(detectTheme());
// Só leads aqui — Campanhas e CRM têm popups próprios na sidebar
const view = ref('leads');
const iframeRef = ref(null);

const src = computed(() => {
  return `/leads/ui/?view=leads&theme=${theme.value}&embed=1`;
});

function pushThemeToIframe() {
  const frame = iframeRef.value;
  if (!frame || !frame.contentWindow) return;
  try {
    frame.contentWindow.postMessage(
      { source: 'chatwoot-theme', theme: theme.value },
      '*'
    );
  } catch (e) {
    /* ignore */
  }
}

let observer;
onMounted(() => {
  observer = new MutationObserver(() => {
    const next = detectTheme();
    if (next !== theme.value) {
      theme.value = next;
      pushThemeToIframe();
    }
  });
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class', 'data-theme', 'color-scheme'],
  });
  if (document.body) {
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }
});
onBeforeUnmount(() => {
  if (observer) observer.disconnect();
});

watch(
  () => props.initialView,
  () => {
    view.value = 'leads';
  }
);
</script>

<template>
  <TfPopupShell label="Prospecção de leads" wide @close="emit('close')">
    <div class="flex flex-col h-full min-h-0">
      <div class="flex items-center gap-2 px-4 pt-4 pb-2 border-b border-n-weak">
        <h2 class="text-base font-semibold text-n-slate-12 m-0">
          Prospecção de leads
        </h2>
      </div>
      <iframe
        ref="iframeRef"
        :key="src"
        class="flex-1 w-full min-h-0 border-0 bg-transparent"
        title="Prospecção"
        :src="src"
        allow="clipboard-write"
        @load="pushThemeToIframe"
      />
    </div>
  </TfPopupShell>
</template>
